import { controls } from "../../controls";


const loandetails = {
  label: "Loan Details",
  pageLabel: "Loan Details",
  starting: true,
  url: "loandetails",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    
    ...controls.magicDateLabel({ label: "Sanction Date", width: "col-sm-2" }),
    ...controls.magicDate({  dateType: "ontype", name: "sanction_date", width: "col-sm-4" }),
  
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({ label: "Sanction Letter No", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Sanction Letter No", name: "sanction_letter_no", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({ label: "Sanction Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Sanction Amount", name: "sanction_amount", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({ label: "Disbursed Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Disbursed Amount", name: "disbursed_amount", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({ label: "Loan Period In Months", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Loan Period", name: "loan_period_in_months", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({label: "Interest Rate",width:"col-sm-2"}),
    ...controls.text({placeHolder: "Interest Rate",name: "interest_rate", width:"col-sm-4"}),
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.magicDateLabel({ label: "Maturity Date", width: "col-sm-2" }),
    ...controls.magicDate({  dateType: "ontype", name: "maturity_date", width: "col-sm-4" }),
  
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({ label: "Sanction By", width: "col-sm-2" }),
    ...controls.SanctionBy({width: "col-sm-4" }),
    ...controls.showData({ name: "sanctionby_display", data: "sanctionby_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Referenced By", width: "col-sm-2" }),
    ...controls.ReferencedBy({ width: "col-sm-4" }),
    ...controls.showData({ name: "referencedby_display", data: "referencedby_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Purpose", width: "col-sm-2" }),
    ...controls.Purpose({ width: "col-sm-4" }),
    ...controls.showData({ name: "purpose_display", data: "purpose_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Priority Sector", width: "col-sm-2" }),
    ...controls.PrioritySector({ width: "col-sm-4" }),
    ...controls.showData({ name: "priority_sector_display", data: "priority_sector_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Priority Segment", width: "col-sm-2" }),
    ...controls.PrioritySegment({ width: "col-sm-4" }),
    ...controls.showData({ name: "priority_segment_display", data: "priority_segment_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Category", width: "col-sm-2" }),
    ...controls.Category({ width: "col-sm-4" }),
    ...controls.showData({ name: "category_display", data: "category_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Industry Type", width: "col-sm-2" }),
    ...controls.IndustryType({ width: "col-sm-4" }),
    ...controls.showData({ name: "industrytype_display", data: "industrytype_display", width: "col-sm-2" }),

    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Health", width: "col-sm-2" }),
    ...controls.Health({ width: "col-sm-4" }),
    ...controls.showData({ name: "health_display", data: "health_display", width: "col-sm-2" }),

    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "CIBIL Account Type", width: "col-sm-2" }),
    ...controls.CIBILAccountType({ width: "col-sm-4" }),
    ...controls.showData({ name: "cibil_account_type_display", data: "cibil_account_type_display", width: "col-sm-2" }),

    
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Society", width: "col-sm-2" }),
    ...controls.Society({ width: "col-sm-4" }),
    ...controls.showData({ name: "society_display", data: "society_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Ref Director", width: "col-sm-2" }),
    ...controls.RefDirector({ width: "col-sm-4" }),
    ...controls.showData({ name: "ref_director_display", data: "ref_director_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Secured", width: "col-sm-2" }),
    ...controls.select({ width: "col-sm-4", name: "secured" ,options: [
      {
        label: "Unsecured",
        value: "Unsecured"
      },
      {
        label: "Secured",
        value: "Secured"
      },
      {
        label: "Partial Secured",
        value: "Partial_Secured"
      }
    ],}),
    ...controls.displayText({ width: "col-sm-6"}),
    ...controls.displayText({ width: "col-sm-2"}),
    ...controls.checkBox({label: "Director Flag",name: "isDirectorFlag",width:"col-sm-4",}),
    ...controls.checkBox({label: "Relative Director Flag",name: "isRelativeDirectorFlag",width:"col-sm-4",}),
    ...controls.displayText({ width: "col-sm-2"}),
    ...controls.displayText({ label: "Relative Director", width: "col-sm-2" }),
    ...controls.RelativeDirector({ width: "col-sm-4" }),
    ...controls.showData({ name: "relative_director_display", data: "relative_director_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-4"}),
    ...controls.displayText({ label: "Relation", width: "col-sm-2" }),
    ...controls.RelationCode({ width: "col-sm-4"}),
    ...controls.showData({ name: "relation_code_display", data: "relation_code_display", width: "col-sm-2" }),
  
  ]
}

export default loandetails;